// constants/themes.ts — mirrors mobile/constants/themes.ts exactly

export type ThemeName = 'slate' | 'obsidian' | 'aurora' | 'ember'

export interface Theme {
  name: ThemeName
  label: string
  // Surfaces
  bg: string
  cardLow: string
  cardMid: string
  cardHigh: string
  border: string
  // Text
  text: string
  textMuted: string
  textDim: string
  // Brand accent
  accent: string
  accentDim: string
  // Semantic — FIXED
  signal: string   // '#6bfb9a'
  noise: string    // '#ff6b6b'
  amber: string    // '#f59e0b'
}

export const THEMES: Record<ThemeName, Theme> = {
  slate: {
    name: 'slate', label: 'Slate',
    bg: '#0f172a', cardLow: '#1e293b', cardMid: '#263044', cardHigh: '#334155',
    border: '#334155', text: '#f1f5f9', textMuted: '#94a3b8', textDim: '#475569',
    accent: '#6bfb9a', accentDim: '#4ade80',
    signal: '#6bfb9a', noise: '#ff6b6b', amber: '#f59e0b',
  },
  obsidian: {
    name: 'obsidian', label: 'Obsidian',
    bg: '#000000', cardLow: '#0d0d0d', cardMid: '#161616', cardHigh: '#1f1f1f',
    border: '#2a2a2a', text: '#f5f5f5', textMuted: '#888888', textDim: '#444444',
    accent: '#60a5fa', accentDim: '#3b82f6',
    signal: '#6bfb9a', noise: '#ff6b6b', amber: '#f59e0b',
  },
  aurora: {
    name: 'aurora', label: 'Aurora',
    bg: '#0d0a1e', cardLow: '#160f2e', cardMid: '#1e1540', cardHigh: '#271d52',
    border: '#352660', text: '#ede9fe', textMuted: '#a78bfa', textDim: '#5b3f8a',
    accent: '#c084fc', accentDim: '#a855f7',
    signal: '#6bfb9a', noise: '#ff6b6b', amber: '#f59e0b',
  },
  ember: {
    name: 'ember', label: 'Ember',
    bg: '#18100a', cardLow: '#241610', cardMid: '#301d14', cardHigh: '#3d2418',
    border: '#4a2d1c', text: '#fef3c7', textMuted: '#d97706', textDim: '#78350f',
    accent: '#fb923c', accentDim: '#ea580c',
    signal: '#6bfb9a', noise: '#ff6b6b', amber: '#f59e0b',
  },
}

export const DEFAULT_THEME: ThemeName = 'slate'

// Spacing scale (px)
export const S = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32, xxxl: 48 }

// Border-radius scale (px)
export const R = { sm: 8, md: 12, lg: 16, xl: 20, xxl: 28, full: 9999 }
